import { formFieldsConfigProcessed } from "./config/FileAttachmentsConfig";
import { formFieldsState } from "./state/FileAttachmentsState";
import { formFieldsValidation } from "./validations/FileAttachmentsValidations";
import { FILE_ATTACHMENTS_CONSTANTS } from "../../constants";

export const formName = FILE_ATTACHMENTS_CONSTANTS.FORM_NAME;
export const formHeader = FILE_ATTACHMENTS_CONSTANTS.FORM_HEADER;
export const formDescription = FILE_ATTACHMENTS_CONSTANTS.FORM_DESCRIPTION;
export const formConfig = formFieldsConfigProcessed;
export const formValidation = formFieldsValidation;
export const formState = formFieldsState;
